export default {
  getJobs: (state) => state.jobs,
  cachedJobs: (state) => state.cachedJobs,
  getCategories: (state) => state.categories,
  cachedCategories: (state) => state.cachedCategories,
  job: (state) => state.job,
  cachedJobId: (state) => state.cachedJobId,
  jobLoading: (state) => state.jobLoading,
  jobsLoading: (state) => state.jobsLoading,
  jobsByCompanyId: (state) => state.jobsByCompanyId,
  cachedJobCompanyId: (state) => state.cachedJobCompanyId,
  jobsFilters: (state) => state.jobsFilters,
};
